<template>
  <div class='h-100 border-box'>
    <!-- 时间选择-->
    <div class='pd-10 bd-b '>
      <div class='uk-flex uk-flex-between'>
        <el-form>
          <el-form-item :label="$t('integration.start')" label-width='50px' prop='startTime'>
            <el-date-picker style='width: auto' type='datetime' :placeholder="$t('public.select_time')"
                            v-model='form.from'
                            value-format='timestamp'></el-date-picker>
          </el-form-item>

          <el-form-item :label="$t('integration.end')" label-width='50px' prop='endTime'>
            <el-date-picker style='width: auto' type='datetime' :placeholder="$t('public.select_time')"
                            v-model='form.to'
                            value-format='timestamp'></el-date-picker>
          </el-form-item>
        </el-form>

        <div class='bg-theme uk-flex uk-flex-middle uk-flex-center ml-5 r-default cursor-pointer'
             style='width: 75px;height: 75px' @click='search'>
          <i class='el-icon-search' style='font-size: 30px'></i>
        </div>
      </div>

    </div>

    <div class='pd-10 uk-padding-remove-bottom uk-flex-1' style='height: calc(100% - 120px)'>
      <div style='height: calc(100% - 40px);overflow-y: auto'>
        <!-- 运输记录-->
        <div :class='{"border-theme":item.id === active}' :key='index' v-for='(item,index) in  list'
             class='border pd-10 mb-5  cursor-pointer' @click='onSelect(item)'>
          {{ $timetransition(item.startTime) }} - {{ $t('运输') }}
        </div>
      </div>

      <div class='color-white uk-flex uk-text-center cursor-pointer pagination'>
        <div class='bg-theme uk-flex-1 btn' @click='prev'>
          {{ $t('上一页') }}
        </div>
        <div class='bg-theme uk-flex-1 btn bd-l' @click='next'>
          {{ $t('下一页') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTransRecord } from '@/api/modules/transport'

export default {
  props: {
    carrierId: {
      required: true
    }
  },
  data () {
    return {
      active: 0,
      form: {
        from: null,
        to: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      },
      list: [],
      disable: false
    }
  },
  watch: {
    carrierId: {
      handler () {
        this.reset()
        this.getTransList()
      },
      immediate: true
    }
  },
  methods: {
    onSelect (item) {
      this.$emit('onSelect', item)
      this.active = item.id
    },
    search () {
      this.reset()

      this.getTransList()
    },
    getTransList () {
      if (this.disable) {
        return
      }

      getTransRecord({
        carrierId: this.carrierId,
        iDisplayStart: this.form.iDisplayStart,
        iDisplayLength: this.form.iDisplayLength,
        from: this.form.from,
        to: this.form.to
      }).then(({ result }) => {
        this.form.from = result.from
        this.form.to = result.to

        if (!result.result.result.length) {
          this.$message.warning('没有更多了！')
          this.form.iDisplayStart -= this.form.iDisplayLength

          this.disable = true
        } else {
          this.list = result.result.result
        }
      })
    },
    reset () {
      this.form.iDisplayStart = 0
      this.form.iDisplayLength = 15
      this.form.from = null
      this.form.to = null
      this.disable = false
    },
    next () {
      this.form.iDisplayStart += this.form.iDisplayLength
      this.getTransList()
    },
    prev () {
      console.log(this.form.iDisplayStart - this.form.iDisplayLength)
      if (this.form.iDisplayStart - this.form.iDisplayLength >= 0) {
        this.form.iDisplayStart -= this.form.iDisplayLength
        this.disable = false
        this.getTransList()
      }
    }
  }
}
</script>

<style lang='scss' scoped>

.pagination {
  .btn {
    height: 30px;
    line-height: 30px;
  }
}
</style>
